import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIcoSuccess = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 100,
	height: 100,
	fill: "#9095B5",
	viewBox: "0 0 27.01 27.01",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M6.64 14.54c-0.22,-0.22 -0.22,-0.56 0,-0.78 0.21,-0.21 0.56,-0.21 0.77,0l3.5 3.5 8.68 -8.68c0.21,-0.21 0.56,-0.21 0.78,0 0.21,0.21 0.21,0.56 0,0.78l-9.07 9.06c-0.22,0.22 -0.56,0.22 -0.78,0l-3.88 -3.88zm6.86 11.37c3.43,0 6.53,-1.39 8.77,-3.64 2.25,-2.24 3.64,-5.34 3.64,-8.77 0,-3.42 -1.39,-6.53 -3.64,-8.77 -2.24,-2.24 -5.34,-3.63 -8.77,-3.63 -3.42,0 -6.53,1.39 -8.77,3.63 -2.24,2.24 -3.63,5.35 -3.63,8.77 0,3.43 1.39,6.53 3.63,8.77 2.24,2.25 5.35,3.64 8.77,3.64zm9.55 -2.86c-2.44,2.44 -5.82,3.96 -9.55,3.96 -3.73,0 -7.1,-1.52 -9.54,-3.96 -2.45,-2.44 -3.96,-5.82 -3.96,-9.55 0,-3.73 1.51,-7.1 3.96,-9.54 2.44,-2.45 5.81,-3.96 9.54,-3.96 3.73,0 7.11,1.51 9.55,3.96 2.44,2.44 3.96,5.81 3.96,9.54 0,3.73 -1.52,7.11 -3.96,9.55z" })
});
export default SvgIcoSuccess;
